'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _inputsStyles = require('../inputsStyles/inputsStyles');
var _createInputWithValidation = require('../inputsFunctions/createInputWithValidation');
var _createInputWithValidation2 = _interopRequireDefault(_createInputWithValidation);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TextArea = function TextArea(_ref) {
  var disabled = _ref.disabled,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    isRequired = _ref.isRequired;
  return _react2.default.createElement(_inputsStyles.StyledTextArea, {
    'data-testid': 'TextArea',
    id: name,
    name: name,
    value: value,
    onChange: onChange,
    type: 'text',
    onBlur: onBlur,
    placeholder: placeholder,
    required: isRequired,
    disabled: disabled
  });
};
TextArea.defaultProps = {
  isRequired: false
};
exports.default = (0, _createInputWithValidation2.default)('text')(TextArea);